// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"247":"d13735a7","333":"4f9a9912","836":"16fc0b96","845":"15033f3f"}[chunkId] + ".css";
};